var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSubProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23.684,
    viewBox: "0 0 20 23.684",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0 23.684)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M20-19.232l-4.632-4.453H5.263v3.618H0V0H14.737V-3.684H20ZM15.526-22.8l3.734,3.592H15.526ZM.526-.526V-19.539H9.737v4.474H14.21V-.526Zm9.737-18.658,3.721,3.592H10.263ZM14.737-4.21V-15.6l-4.632-4.474H5.79v-3.087H15v4.474h4.474V-4.21Z",
    fill: "#00b3ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSubProject);
export default __webpack_public_path__ + "static/media/addSubProject.04b9997a2525831d56729d59e60c5adc.svg";
export { ForwardRef as ReactComponent };